import globals from '../globals/communityGlobals';

const locale = globals.getArea('autoAllocationMode');

export const AutoAllocationMode = {
  general: 0,
  clinicianGroups: 1,
  phoneCalls: 2,
  excludedRagStatuses: 3,
};

export const AutoAllocationModeOptions = еnableAutoAllocateWithoutRagStatus =>
  Object.keys(AutoAllocationMode).reduce((result, key) => {
    if (key !== 'excludedRagStatuses' || еnableAutoAllocateWithoutRagStatus === 'true') {
      result.push(Object.create({ id: AutoAllocationMode[key], name: locale.getMsg(key) }));
    }
    return result;
  }, []);
